<template>
  <div v-if="!!$props.errors.length" class="mb-3">
    <BaseAlert
      v-for="(error, index) in $props.errors"
      :key="`bdx-wizard-error-${index}`"
      variant="danger"
      class="py-2 px-3"
      :class="{
        'mb-2': index < lastIndex,
        'mb-0': index === lastIndex
      }"
    >
      <strong class="text-capitalize font-weight-bold"
        >{{ error.label }}:</strong
      >
      {{ error.message }}
    </BaseAlert>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { BaseAlert } from '@components/base'

export default defineComponent({
  name: 'ErrorMessages',
  components: {
    BaseAlert
  },
  props: {
    errors: {
      type: Array,
      default: () => [],
      validate: (value) => {
        return value.every((error) => {
          return (
            typeof error.label === 'string' && typeof error.message === 'string'
          )
        })
      }
    }
  },
  setup(props) {
    const lastIndex = computed(() => props.errors.length - 1)

    return {
      lastIndex
    }
  }
})
</script>
